import { AfterViewInit, Component, ViewChild } from "@angular/core";
import { MatPaginator } from "@angular/material/paginator";
import { MatSort } from "@angular/material/sort";
import { MatTableDataSource } from "@angular/material/table";
import { faSpinner } from "@fortawesome/free-solid-svg-icons";
import { finalize } from "rxjs/operators";
import {
  ApprovedPriceResult,
  ApprovedServicePriceModalComponent,
} from "src/app/components/admin/approved-service-price/approved-service-price-modal/approved-service-price-modal.component";
import LocalizationConstants from "src/app/constants/localization-constants";
import RouteNameConstants from "src/app/constants/route-name-constants";
import { CompanyListItem } from "src/app/models/CompanyListItem";
import { VisibleEvent } from "src/app/models/VisibleEvent";
import { ApprovedPriceService } from "src/app/services/approved-price-service";
import { CompanyService } from "src/app/services/company.service";
import { GlobalOverlayService } from "src/app/services/global-overlay.service";
import { ModalService } from "src/app/services/modal.service";

@Component({
  selector: "app-approved-service-price",
  templateUrl: "./approved-service-price.component.html",
  styleUrls: ["./approved-service-price.component.scss"],
  standalone: false,
})
export class ApprovedServicePriceComponent implements AfterViewInit {
  readonly routeNameConstants = RouteNameConstants;
  readonly localizationConstants = LocalizationConstants;

  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;

  faSpinner = faSpinner;
  dataSource = new MatTableDataSource<CompanyListItem>();
  item: string[];
  visibleEvents: VisibleEvent[];
  isLoading: boolean;

  fam: string;
  role: string;
  events: VisibleEvent[];
  page: number = 1;
  pageSize: number = 10;
  fams: string[];

  constructor(
    private approvedPriceService: ApprovedPriceService,
    private globalOverlayService: GlobalOverlayService,
    public modalService: ModalService,
    public companyService: CompanyService,
  ) {
    this.getFamList();
  }

  ngAfterViewInit() {
    this.dataSource.sort = this.sort;
    this.dataSource.paginator = this.paginator;
  }

  getFamList() {
    this.globalOverlayService.show();
    this.companyService
      .getFamCodes()
      .pipe(finalize(() => this.globalOverlayService.close()))
      .subscribe((response) => {
        if (!response) return;
        this.fams = response;
      });
  }

  getItemsList() {
    this.globalOverlayService.show();
    this.approvedPriceService
      .getItems(this.fam)
      .pipe(finalize(() => this.globalOverlayService.close()))
      .subscribe((response) => {
        if (!response) return;
        this.dataSource.data = response;
      });
  }

  activate(item) {
    this.globalOverlayService.show();
    this.approvedPriceService
      .update({
        company: this.fam,
        value: item.value,
        listType: item.listType,
        customBoolean1: item.customBoolean1,
      })
      .pipe(finalize(() => this.globalOverlayService.close()))
      .subscribe((response) => {
        if (!response) return;
      });
  }

  remove(item) {
    this.globalOverlayService.show();

    const index = this.dataSource.data.findIndex((e) => e.value === item.value);

    this.approvedPriceService
      .delete({
        company: this.fam,
        value: item.value,
        listType: item.listType,
        customBoolean1: item.customBoolean1,
      })
      .pipe(finalize(() => this.globalOverlayService.close()))
      .subscribe((response) => {
        if (!response) return;
        if (index > -1) {
          this.dataSource.data.splice(index, 1);
          this.dataSource.data = [...this.dataSource.data];
        }
      });
  }

  addNewItem({ value, poMandatory }: ApprovedPriceResult) {
    this.globalOverlayService.show();
    this.approvedPriceService
      .addMaxPrice({
        company: this.fam,
        customBoolean1: Boolean(poMandatory),
        value: value,
      })
      .pipe(
        finalize(() => {
          this.modalService.close();
          this.globalOverlayService.close();
        }),
      )
      .subscribe((response) => {
        if (!response) return;
        this.dataSource.data = [
          new CompanyListItem(this.fam, value, poMandatory),
          ...this.dataSource.data,
        ];
      });
  }

  openModal() {
    this.modalService.openDefaultModal(ApprovedServicePriceModalComponent).subscribe((result) => {
      if (!result) return;
      this.addNewItem(result);
    });
  }

  onChange() {
    this.getItemsList();
  }
}
